import { render } from "./ActionReasons.vue?vue&type=template&id=527172fc&scoped=true"
import script from "./ActionReasons.vue?vue&type=script&lang=js"
export * from "./ActionReasons.vue?vue&type=script&lang=js"

import "./ActionReasons.vue?vue&type=style&index=0&id=527172fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527172fc"]])

export default __exports__